import { Box, Chip, FormControl, InputLabel, MenuItem, OutlinedInput, Select, SelectChangeEvent } from "@mui/material";
import React, { useState } from "react";

const Index = (props: { register: any; handleSubmit: any; errors: any; formValue: any; setFormValue: any; handleNext: any; }) => {
    const [risks, setRisks] = useState<string[]>([])
    const [habits, setHabits] = useState<string[]>([])

    const riskandHabits = {
        risks: risks,
        habits: habits
    }

    const onSubmit = (data: any) => {
        props.setFormValue({
            ...props.formValue,
            riskandHabits: riskandHabits,
        });

        props.handleNext();
    };    

    const riskFactors = [
        "Diabetis",
        "HyperTension",
    ]

    const humanhabits = [
        "Smoking",
        "Alcoholic",
    ]

    const handleChange = (e: SelectChangeEvent<typeof risks>) => {
        const { target: { value } } = e;

        setRisks(typeof value === 'string' ? value.split(',') : value,)
    }

    const handleChange2 = (e: SelectChangeEvent<typeof habits>) => {
        const { target: { value } } = e;

        setHabits(typeof value === 'string' ? value.split(',') : value,)
    }

    return <form id="page3" onSubmit={props.handleSubmit(onSubmit)}>
        <div className="grid grid-cols-2 gap-2 m-2">
            <FormControl>
                <InputLabel id="riskFactor">Risk Factors</InputLabel>
                <Select labelId="riskFactor" size="small" multiple
                    value={risks.length > 0 && props.formValue?.riskandHabits?.risks !== undefined
                        ?
                        risks
                        :
                        risks.length > 0
                            ?
                            risks : risks.length <= 0 && props.formValue?.riskandHabits?.risks !== undefined
                                ?
                                props.formValue?.riskandHabits?.risks : []
                    }
                    renderValue={
                        (selected) => (
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                {selected.map((value) => (
                                    <Chip key={value} label={value} />
                                ))}
                            </Box>
                        )}
                    input={<OutlinedInput label="Risk Factors" />}
                    onChange={handleChange}
                >
                    {riskFactors.map((risk) => (
                        <MenuItem key={risk} value={risk}>{risk}</MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormControl>
                <InputLabel id="humanHabit">Human Habit</InputLabel>
                <Select labelId="humanHabit" size="small" multiple
                    value={habits.length > 0 && props.formValue?.riskandHabits?.habits !== undefined
                        ?
                        habits
                        :
                        habits.length > 0
                            ?
                            habits : habits.length <= 0 && props.formValue?.riskandHabits?.habits !== undefined
                                ?
                                props.formValue?.riskandHabits?.habits : []
                    }
                    renderValue={
                        (selected) => (
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                {selected.map((value) => (
                                    <Chip key={value} label={value} />
                                ))}
                            </Box>
                        )}
                    input={<OutlinedInput label="Human Habit" />}
                    onChange={handleChange2}
                >
                    {humanhabits.map((habit) => (
                        <MenuItem key={habit} value={habit}>{habit}</MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    </form>;
};

export default Index;
